import React from "react";
import styled, { css, keyframes } from "styled-components";

const pulse = keyframes`
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.8; }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ cols }) => cols}, ${({ cell }) => cell}px);
  grid-template-rows: repeat(${({ rows }) => rows}, ${({ cell }) => cell}px);
  gap: ${({ gap }) => gap}px;
  flex-shrink: 0;
`;

const Cell = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 2px;
  background: ${({ filled }) =>
    filled ? "var(--nd-text-display)" : "var(--nd-text-disabled)"};
  opacity: ${({ filled, pulsing }) => (filled ? 1 : pulsing ? 0.3 : 0.15)};
  ${({ pulsing }) => pulsing && css`animation: ${pulse} 3s ease-in-out infinite;`}
`;

const ProgressGrid = ({
  rows = 5, cols = 5, filled = 0, pulsingNext = true, cell = 16, gap = 6, ariaLabel,
}) => {
  const total = rows * cols;
  const cells = Array.from({ length: total }, (_, i) => ({
    filled: i < filled,
    pulsing: pulsingNext && i === filled,
  }));
  return (
    <Grid cols={cols} rows={rows} cell={cell} gap={gap} aria-label={ariaLabel || `${filled} of ${total}`}>
      {cells.map((c, i) => (
        <Cell key={i} size={cell} filled={c.filled} pulsing={c.pulsing} />
      ))}
    </Grid>
  );
};

export default ProgressGrid;
